import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

const AdBanner = () => {
  return (
    <Paper
      sx={{
        p: 2,
        backgroundColor: '#f5f5f5',
        borderRadius: 2,
        border: '1px dashed #bdbdbd',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 100,
          backgroundColor: '#e0e0e0',
          borderRadius: 1,
        }}
      >
        <Typography variant="h6" color="text.secondary">
          Votre publicité ici
        </Typography>
      </Box>
    </Paper>
  );
};

export default AdBanner;